import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import selectors from 'selectors'
import locationActions from 'actions/locations'
import locationGroupActions from 'actions/locationGroups'
import userActions from 'actions/users'
import productCategoryActions from 'actions/productCategories'
import supplierActions from 'actions/suppliers'
import Component from 'components/Reports/LocationCountStockOutReport/Filter'

const mapStateToProps = (state, props) => ({
  ...createAuthStateToProps(state, props),
  locationGroups: selectors.locationGroups.selectOptions(state),
  locations: selectors.locations.selectOptions(state),
  users: selectors.users.selectOptions(state),
  productCategories: selectors.productCategories.selectOptions(state),
  suppliers: selectors.suppliers.selectOptions(state, { itemsOnly: false }),
})

const mapDispatchToProps = (dispatch, props) => ({
  getLocationGroups: (params) => dispatch(locationGroupActions.getOptions(params)),
  getLocations: (params) => dispatch(locationActions.getOptions({ locationVendingTypes: ['NonVending'], ...params })),
  getUsers: (params) => dispatch(userActions.getOptions({ ...params, active: 'All' })),
  getProductCategories: (params) =>
    dispatch(productCategoryActions.getOptions({ ...params, active: 'All', pageIndex: 0 })),
  getSuppliers: (params) =>
    dispatch(
      supplierActions.getOptions({
        pageIndex: 1,
        pageSize: 100,
        ...params,
        active: 'All',
      }),
    ),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
